import react from "../assets/icons/react.svg";
import nextjs from "../assets/icons/nextjs.svg";
import angular from "../assets/icons/angular.svg";
import html5 from "../assets/icons/html5.svg";
import css3 from "../assets/icons/css3.svg";
import java from "../assets/icons/java.svg";
import javascript from "../assets/icons/javascript.svg";
import nodejs from "../assets/icons/nodejs.svg";
import mongodb from "../assets/icons/mongodb.svg";
import postgresql from "../assets/icons/postgresql.svg";
import docker from "../assets/icons/docker.svg";

export const TECHNOLOGIES = [
    {
      name: "React",
      img_url: react,
    },
    {
      name: "Next.js",
      img_url: nextjs,
    },
    {
      name: "Angular",
      img_url: angular,
    },
    {
      name: "HTML",
      img_url: html5,
    },
    {
      name: "CSS",
      img_url: css3,
    },
    {
      name: "Java",
      img_url: java,
    },
    {
      name: "JavaScript",
      img_url: javascript,
    },
    {
      name: "Node.js",
      img_url: nodejs,
    },
    {
      name: "MongoDB",
      img_url: mongodb,
    },
    {
      name: "PostgreSQL",
      img_url: postgresql,
    },
    {
      name: "Docker",
      img_url: docker,
    }
  ];
